import { render, staticRenderFns } from "./SvgBackTo.vue?vue&type=template&id=332d0d2e&"
import script from "./SvgBackTo.vue?vue&type=script&lang=js&"
export * from "./SvgBackTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports